/**
 * UnixCard como forma de pagamento no link de venda direta.
 *
 * O UnixCard é exclusivo da Unixbank. A marca vem de GET /busca-uuid: o
 * middleware resolve a marca pelo `x-caller-url` e a API devolve `tipo` e `id`
 * (id_FRANQUIA_MARCA_PROPRIA). O dado sai do servidor, e não do settings.json
 * nem do `pageTitle`, que podem mudar sem que a marca mude.
 *
 * É a mesma regra que a API aplica ao recusar o UNIXCARD de outras marcas
 * (OperacoesController::ativacao, MetodoPagamentoValidoAtivacao: marca de
 * referência 113). Se a API mudar a regra, este helper muda junto. Aqui a
 * decisão é só de exibição: quem barra a compra é a API.
 *
 * Fica aqui, e não nos componentes, porque a decisão é da marca e o link de
 * venda direta não pode ter lógica de MVNO dentro de componente React (ver
 * CLAUDE.md).
 */
export const ID_MARCA_UNIXBANK = 113

export interface UnixcardEnabledInput {
  tipo?: unknown
  id?: unknown
}

/**
 * Se a marca do link oferece o UnixCard. Campo ausente ou inválido desliga:
 * na dúvida o cliente paga com cartão de crédito, que toda marca aceita.
 */
export function isUnixcardEnabled({ tipo, id }: UnixcardEnabledInput): boolean {
  if (tipo !== 'mvno') return false
  if (typeof id !== 'number' && typeof id !== 'string') return false
  if (typeof id === 'string' && id.trim() === '') return false
  return Number(id) === ID_MARCA_UNIXBANK
}
